import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, SelectProps } from '@mui/material';

interface EnumSelectProps {
  readonly value: number | string;
  readonly onChange: (value: number) => void;
  readonly label: string;
  readonly options: Array<{ value: number; label: string }>;
  readonly required?: boolean;
  readonly error?: boolean;
  readonly fullWidth?: boolean;
  readonly placeholder?: string;
  readonly slotProps?: SelectProps['slotProps'];
}

export const EnumSelect: React.FC<EnumSelectProps> = ({
  value,
  onChange,
  label,
  options,
  required = false,
  error = false,
  fullWidth = true,
  placeholder = '選択してください',
  slotProps = {},
}) => {
  return (
    <FormControl fullWidth={fullWidth} required={required} error={error}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        label={label}
        slotProps={slotProps}
      >
        <MenuItem value=''>{placeholder}</MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
